<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3 col-xl-2 bg-light">
        <AppSidebar/>
      </div>
      <div class="col bg-white">
        <AppHeader/>
        <AppContent/>
      </div>
    </div>
    <AppNotification/>
  </div>
</template>
<script setup>
import AppSidebar from '@/components/AppSidebar.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppContent from '@/components/AppContent.vue'
import AppNotification from "@/components/AppNotification";
</script>
